import React from "react";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableHeader,
    Badge,
} from "../../../components/ui";

const DEFAULT_IMAGE =
    "https://firebasestorage.googleapis.com/v0/b/deliveryapp-e121f.appspot.com/o/guille%2Fimages%2F84e40303-c3c6-4eeb-bd3c-064afb593ba5?alt=media&token=3a87c275-6b64-40e0-801b-88b0719efa8e";

const thClass =
    "px-4 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400";

const classificationBadge = {
    B: "bg-gray-200 dark:bg-gray-600 text-gray-800 dark:text-gray-200",
    P: "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300",
    default: "bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300",
};

export function ProductList({
    filteredProducts,
    onOpenProductModal,
    onOpenTariffModal,
}) {
    return (
        <div className="space-y-4">
            <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                <button
                    type="button"
                    className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-6 py-3 text-lg font-medium text-white shadow-md transition-colors hover:bg-blue-700"
                    onClick={() => onOpenProductModal({})}
                >
                    <i className="fas fa-plus" aria-hidden="true" />
                    Agregar Nuevo Producto
                </button>

                <div className="flex items-center gap-2 rounded-lg bg-gray-100 px-4 py-2 shadow-sm dark:bg-gray-700">
                    <i
                        className="fas fa-boxes text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                    />
                    <span className="text-sm font-medium text-gray-600 dark:text-gray-300">
                        Total productos:
                    </span>
                    <Badge variant="primary" className="px-2 py-0.5 text-sm">
                        {filteredProducts.length}
                    </Badge>
                </div>
            </div>

            {filteredProducts.length === 0 ? (
                <div className="rounded-lg border border-gray-200 bg-white p-8 text-center shadow-sm dark:border-gray-700 dark:bg-gray-800">
                    <i
                        className="fas fa-boxes mb-3 text-4xl text-gray-400"
                        aria-hidden="true"
                    />
                    <p className="mb-1 text-lg font-semibold text-gray-700 dark:text-gray-300">
                        No hay productos disponibles
                    </p>
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                        Agrega un nuevo producto para comenzar
                    </p>
                </div>
            ) : (
                <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800">
                    <Table className="min-w-[960px] table-fixed text-sm">
                        <TableHead>
                            <tr>
                                <TableHeader className={`${thClass} w-24`}>
                                    <i className="fas fa-image mr-1" aria-hidden="true" />
                                    Imagen
                                </TableHeader>
                                <TableHeader className={`${thClass} w-28`}>
                                    <i className="fas fa-barcode mr-1" aria-hidden="true" />
                                    Código
                                </TableHeader>
                                <TableHeader className={`${thClass} w-[28%]`}>
                                    <i className="fas fa-tag mr-1" aria-hidden="true" />
                                    Producto
                                </TableHeader>
                                <TableHeader className={`${thClass} w-[14%]`}>
                                    <i className="fas fa-industry mr-1" aria-hidden="true" />
                                    Marca
                                </TableHeader>
                                <TableHeader className={`${thClass} w-[14%]`}>
                                    <i className="fas fa-users mr-1" aria-hidden="true" />
                                    Grupo
                                </TableHeader>
                                <TableHeader className={`${thClass} w-[18%]`}>
                                    <i className="fas fa-tags mr-1" aria-hidden="true" />
                                    Tarifarios
                                </TableHeader>
                                <TableHeader className={`${thClass} w-28`}>
                                    <i className="fas fa-toggle-on mr-1" aria-hidden="true" />
                                    Estado
                                </TableHeader>
                                <TableHeader
                                    align="center"
                                    className={`${thClass} w-28`}
                                >
                                    <i className="fas fa-cogs mr-1" aria-hidden="true" />
                                    Acciones
                                </TableHeader>
                            </tr>
                        </TableHead>

                        <TableBody>
                            {filteredProducts.map((item, index) => {
                                const imageSrc = item.path
                                    ? item.path.replaceAll(".png", "_thumb_100.png")
                                    : DEFAULT_IMAGE;

                                const classificationKey =
                                    item.classification === "B" || item.classification === "P"
                                        ? item.classification
                                        : "default";

                                return (
                                    <TableRow key={index} hover className="align-top">
                                        <TableCell className="w-24">
                                            <div className="mx-auto flex h-16 w-16 shrink-0 items-center justify-center overflow-hidden rounded-md border border-gray-200 bg-gray-50 dark:border-gray-600 dark:bg-gray-700/50">
                                                <img
                                                    src={imageSrc}
                                                    alt={item.saleName || "Producto"}
                                                    className="h-full w-full object-contain p-1"
                                                    onError={(ev) => {
                                                        ev.target.src = DEFAULT_IMAGE;
                                                        ev.target.onerror = null;
                                                    }}
                                                />
                                            </div>
                                        </TableCell>

                                        <TableCell className="w-28">
                                            <button
                                                type="button"
                                                className={`rounded-lg border px-3 py-1 text-sm font-semibold transition-colors ${
                                                    item.isGroup
                                                        ? "border-gray-700 bg-gray-800 text-white dark:border-gray-800 dark:bg-gray-900"
                                                        : "border-blue-600 text-blue-600 hover:bg-blue-50 dark:border-blue-400 dark:text-blue-400 dark:hover:bg-blue-900/30"
                                                }`}
                                                onClick={() => onOpenProductModal(item)}
                                            >
                                                # {Number(item.code).toFixed(2)}
                                            </button>
                                        </TableCell>

                                        <TableCell className="break-words">
                                            <p className="mb-1 font-semibold leading-snug text-gray-900 dark:text-white">
                                                {item.saleName}
                                            </p>
                                            <p className="mb-2 text-xs text-gray-500 dark:text-gray-400">
                                                {item.purchaseName}
                                            </p>
                                            <dl className="space-y-1 text-xs text-gray-600 dark:text-gray-300">
                                                <div className="flex flex-wrap gap-x-1">
                                                    <dt className="font-semibold">SKU:</dt>
                                                    <dd>{item.sku}</dd>
                                                </div>
                                                <div className="flex flex-wrap gap-x-1">
                                                    <dt className="font-semibold">EAN:</dt>
                                                    <dd>
                                                        {!item.ean ||
                                                        item.ean === "None" ||
                                                        item.ean === "null"
                                                            ? "No disponible"
                                                            : item.ean}
                                                    </dd>
                                                </div>
                                                <div className="flex flex-wrap items-center gap-x-1 gap-y-1">
                                                    <dt className="font-semibold">
                                                        Clasificación:
                                                    </dt>
                                                    <dd>
                                                        <span
                                                            className={`inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ${classificationBadge[classificationKey]}`}
                                                        >
                                                            {item.classification === "B"
                                                                ? "BRONCE"
                                                                : item.classification === "P"
                                                                  ? "PLATA"
                                                                  : "ORO"}
                                                        </span>
                                                    </dd>
                                                </div>
                                            </dl>
                                        </TableCell>

                                        <TableCell className="break-words">
                                            <p className="font-medium text-gray-900 dark:text-white">
                                                {item.productBrandName}
                                            </p>
                                        </TableCell>

                                        <TableCell className="break-words">
                                            {item.isGroup ? (
                                                <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-1 text-xs font-semibold text-blue-800 dark:bg-blue-900/30 dark:text-blue-300">
                                                    <i
                                                        className="fas fa-users mr-1"
                                                        aria-hidden="true"
                                                    />
                                                    CABEZA DE GRUPO
                                                </span>
                                            ) : (
                                                <span className="text-sm text-gray-600 dark:text-gray-400">
                                                    {item.parentProductName}
                                                </span>
                                            )}
                                        </TableCell>

                                        <TableCell>
                                            <div className="flex flex-col gap-1">
                                                <Badge
                                                    variant="primary"
                                                    className="w-fit px-2 py-0.5 text-xs"
                                                >
                                                    {item.productTariffList.length}{" "}
                                                    presentación(es)
                                                </Badge>

                                                {item.productTariffList.map((tariff, tIndex) => (
                                                    <button
                                                        key={tIndex}
                                                        type="button"
                                                        className={`w-fit rounded-lg border px-3 py-1 text-left text-xs font-semibold transition-colors ${
                                                            item.available
                                                                ? "border-cyan-600 text-cyan-600 hover:bg-cyan-50 dark:border-cyan-400 dark:text-cyan-400 dark:hover:bg-cyan-900/30"
                                                                : "border-gray-400 text-gray-600 hover:bg-gray-50 dark:border-gray-500 dark:text-gray-400 dark:hover:bg-gray-700/30"
                                                        }`}
                                                        onClick={() => {
                                                            tariff.productSaleName = item.saleName;
                                                            onOpenTariffModal(tariff);
                                                        }}
                                                        title={`Editar ${tariff.unitName}`}
                                                    >
                                                        <i
                                                            className="fas fa-edit mr-1"
                                                            aria-hidden="true"
                                                        />
                                                        {tariff.unitName}
                                                    </button>
                                                ))}

                                                <button
                                                    type="button"
                                                    className={`w-fit rounded-lg px-3 py-1 text-left text-xs font-semibold text-white transition-colors ${
                                                        item.available
                                                            ? "bg-green-600 hover:bg-green-700"
                                                            : "bg-red-600 hover:bg-red-700"
                                                    }`}
                                                    onClick={() =>
                                                        onOpenTariffModal({
                                                            productTariffID: "0",
                                                            unitID: "0",
                                                            unitName: "",
                                                            productSaleName: item.saleName,
                                                            productID: item.productID,
                                                            priceSale: "",
                                                            pricePurchase: "",
                                                            percentageDiscount: "",
                                                            quantityMinimum: "",
                                                        })
                                                    }
                                                    title="Agregar nueva presentación"
                                                >
                                                    <i
                                                        className="fas fa-plus mr-1"
                                                        aria-hidden="true"
                                                    />
                                                    Nueva
                                                </button>
                                            </div>
                                        </TableCell>

                                        <TableCell>
                                            <div className="flex flex-col gap-1">
                                                <Badge
                                                    variant={
                                                        item.available ? "success" : "danger"
                                                    }
                                                    className="w-fit px-2 py-0.5 text-xs"
                                                >
                                                    {item.available
                                                        ? "DISPONIBLE"
                                                        : "NO DISPONIBLE"}
                                                </Badge>
                                                {item.isGroup && (
                                                    <Badge
                                                        variant="primary"
                                                        className="w-fit px-2 py-0.5 text-xs"
                                                    >
                                                        GRUPO
                                                    </Badge>
                                                )}
                                            </div>
                                        </TableCell>

                                        <TableCell align="center">
                                            <button
                                                type="button"
                                                className="inline-flex items-center rounded-lg border border-blue-600 px-3 py-1 text-sm font-semibold text-blue-600 transition-colors hover:bg-blue-50 dark:border-blue-400 dark:text-blue-400 dark:hover:bg-blue-900/30"
                                                onClick={() => onOpenProductModal(item)}
                                                title="Editar Producto"
                                            >
                                                <i
                                                    className="fas fa-edit mr-1"
                                                    aria-hidden="true"
                                                />
                                                Editar
                                            </button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </div>
            )}
        </div>
    );
}
